"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SpeedFactor_service_1 = __importDefault(require("./Service/SpeedFactor.service"));
var SpeedFactor = /** @class */ (function () {
    function SpeedFactor(session) {
        this.speedFactorService = new SpeedFactor_service_1.default(session);
    }
    SpeedFactor.prototype.create = function (configuration) {
        return this.speedFactorService.create(configuration);
    };
    SpeedFactor.prototype.list = function (serviceAreaId) {
        return this.speedFactorService.list(serviceAreaId);
    };
    SpeedFactor.prototype.update = function (payload) {
        return this.speedFactorService.update(payload);
    };
    SpeedFactor.prototype.updateSeries = function (payload) {
        return this.speedFactorService.updateSeries(payload);
    };
    SpeedFactor.prototype.delete = function (dbId) {
        return this.speedFactorService.delete(dbId);
    };
    SpeedFactor.prototype.deleteSeries = function (originalUuid) {
        return this.speedFactorService.deleteSeries(originalUuid);
    };
    return SpeedFactor;
}());
exports.default = SpeedFactor;
//# sourceMappingURL=SpeedFactor.js.map